import { useEffect, useRef } from "react";

export const useEffectSkipFirst = (effect, deps) => {
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    return effect();
  }, deps);
};
